import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';

import { Button, SectionTitle, TextBlock } from '@/ui/index';
import InputAutoComplete from '@/ui/InputAutoComplete/InputAutoComplete';
import { AvailablePhone, CloseSquare, NotAvailablePhone } from '@/icons/index';

import styles from './CheckCompatibility.module.scss';

const CheckCompatibility = ({ data, className }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');
  const [available, setAvailable] = useState(null);
  const modelsNames = useMemo(() => {
    let models = [];
    data?.brands?.map((item) =>
      item.models.forEach((model) => {
        models = [...models, model];
      }),
    );

    return models;
  }, [data]);

  const onCheck = () => {
    setAvailable(
      modelsNames
        ?.map((item) => item?.name?.toLowerCase())
        .includes(value?.toLowerCase()),
    );
  };
  return (
    <div
      className={classNames([
        styles.container,
        className,
        styles.volte__search,
      ])}
      itemScope
      itemType='https://schema.org/CheckAction'
    >
      <SectionTitle className={styles.volte__search__title}>
        {data?.title}
      </SectionTitle>
      <TextBlock className={styles.text}>{data?.description}</TextBlock>
      <div className={styles.find}>
        {available === null ? (
          <InputAutoComplete
            setValue={setValue}
            value={value}
            onSelect={setValue}
            className={styles.input}
            models={modelsNames}
            placeholder={t('common:Device')}
            highlight
          />
        ) : (
          <div
            className={classNames([
              styles.available,
              { [styles.notAvailable]: !available },
            ])}
          >
            <span className={classNames(['label', styles.inputLabel])}>
              {data?.input_label}
            </span>
            <div className={styles.content}>
              {available ? (
                <AvailablePhone className={styles.active_check} />
              ) : (
                <NotAvailablePhone />
              )}
              <span className={styles.title}>{value}</span>
            </div>
            <button
              className={styles.close}
              aria-label='Bakcell'
              onClick={() => setAvailable(null)}
            >
              <CloseSquare width={15} height={15} />
            </button>
          </div>
        )}
        <Button disabled={!value} className={styles.button} onClick={onCheck}>
          {data?.button_text}
        </Button>
      </div>
    </div>
  );
};

export default CheckCompatibility;
